import Api from './Api';

class LogicBaseStoriesApi extends Api {
  url = 'logicbasestories';
}

const singleton = new LogicBaseStoriesApi();
export default singleton;
